import { Card } from "antd";
import React from "react";
import { CardGridItem } from "../../../components";
import { Container } from "../../../components";
import { useStores } from "../../../store";
export var GetTatumApiKey = function GetTatumApiKey() {
  var _apiKeyStore$apiKey, _apiKeyStore$apiKey2, _apiKeyStore$apiKey3, _apiKeyStore$apiKey4, _apiKeyStore$apiKey5, _apiKeyStore$apiKey6;

  var _useStores = useStores(),
      apiKeyStore = _useStores.apiKeyStore;

  var gridStyle = {
    width: "100%",
    align: "center"
  };
  return /*#__PURE__*/React.createElement(Container, {
    isGridCard: true
  }, /*#__PURE__*/React.createElement(Card, {
    title: "Step 1 - Get your API key"
  }, /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Start - $9 per month",
    description: "Credits: 1,000,000",
    secondDescription: "Billed monthly",
    buttonText: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey === void 0 ? void 0 : _apiKeyStore$apiKey.plan) === "Free" ? "Current key" : "Get API key",
    buttonType: "primary",
    buttonLink: "https://dashboard.tatum.io",
    buttonDisabled: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey2 = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey2 === void 0 ? void 0 : _apiKeyStore$apiKey2.plan) === "Start"
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Basic - $49 per month",
    description: "Credits: 5,000,000",
    secondDescription: "Billed monthly",
    buttonText: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey3 = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey3 === void 0 ? void 0 : _apiKeyStore$apiKey3.plan) === "Basic" ? "Current key" : "Get API key",
    buttonType: "primary",
    buttonLink: "https://dashboard.tatum.io",
    buttonDisabled: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey4 = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey4 === void 0 ? void 0 : _apiKeyStore$apiKey4.plan) === "Basic"
  }), /*#__PURE__*/React.createElement(CardGridItem, {
    title: "Advanced - $249 per month",
    description: "Credits: 25,000,000",
    secondDescription: "Billed monthly",
    buttonText: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey5 = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey5 === void 0 ? void 0 : _apiKeyStore$apiKey5.plan) === "Advanced" ? "Current key" : "Get API key",
    buttonType: "primary",
    buttonLink: "https://dashboard.tatum.io",
    buttonDisabled: (apiKeyStore === null || apiKeyStore === void 0 ? void 0 : (_apiKeyStore$apiKey6 = apiKeyStore.apiKey) === null || _apiKeyStore$apiKey6 === void 0 ? void 0 : _apiKeyStore$apiKey6.plan) === "Advanced"
  })));
};